import { Collection } from 'modules/core/lib/mobx-rest'

import Report from 'modules/reports/store/models/Report'

class Reports extends Collection<Report> {
  get cacheKey(): string {
    return 'reports'
  }

  model() {
    return Report
  }
}

const singleton: Reports = new Reports()

export default singleton
